/**
 * Formats a monetary cost using the platform `Intl` currency formatter, showing
 * an extra fraction digit for sub-unit amounts. Falls back to a plain
 * `amount currency` string when the currency code is not recognized. Pure.
 */
export function formatCost(cost: { amount: number; currency: string }): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: cost.currency,
      maximumFractionDigits: cost.amount < 1 ? 3 : 2,
    }).format(cost.amount);
  } catch {
    return `${cost.amount.toFixed(2)} ${cost.currency}`;
  }
}

/** Compact large sidebar metrics without losing precision for small values. */
export function formatCompactCount(value: number): string {
  return new Intl.NumberFormat(undefined, {
    notation: Math.abs(value) >= 10_000 ? 'compact' : 'standard',
    maximumFractionDigits: 1,
  }).format(value);
}
